"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import NextLink from "next/link";
import { useClientProductId } from "@/contexts/client-product-id";
import { cva } from "class-variance-authority";
import { buttonVariants } from "../ui/button";
import { cn } from "@/lib/utils";
const linkVariants = cva("", {
  variants: {
    variant: {
      default: "underline",
      noUnderline: "",
      hoverUnderline: "no-underline hover:underline transition-all"
    }
  },
  defaultVariants: {
    variant: "default"
  }
});
export default function Link(t0) {
  const $ = _c(35);
  let asButton;
  let children;
  let className;
  let href;
  let iconOnly;
  let prefetch;
  let props;
  let size;
  let t1;
  let variant;
  if ($[0] !== t0) {
    ({
      href,
      children,
      className,
      variant,
      prefetch,
      asButton,
      size,
      iconOnly,
      additionalTokens: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = asButton;
    $[2] = children;
    $[3] = className;
    $[4] = href;
    $[5] = iconOnly;
    $[6] = prefetch;
    $[7] = props;
    $[8] = size;
    $[9] = t1;
    $[10] = variant;
  } else {
    asButton = $[1];
    children = $[2];
    className = $[3];
    href = $[4];
    iconOnly = $[5];
    prefetch = $[6];
    props = $[7];
    size = $[8];
    t1 = $[9];
    variant = $[10];
  }
  let t2;
  if ($[11] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[11] = t1;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  const additionalTokens = t2;
  const t3 = useClientProductId();
  let processedHref;
  let t4;
  if ($[13] !== additionalTokens || $[14] !== href || $[15] !== t3) {
    const defaultTokens = {
      clientProductId: t3
    };
    const tokens = {
      ...defaultTokens,
      ...additionalTokens
    };
    processedHref = Object.entries(tokens).reduce(_temp, href);
    t4 = !processedHref.startsWith("/") && !processedHref.startsWith("#");
    $[13] = additionalTokens;
    $[14] = href;
    $[15] = t3;
    $[16] = processedHref;
    $[17] = t4;
  } else {
    processedHref = $[16];
    t4 = $[17];
  }
  const isExternal = t4;
  let t5;
  if ($[18] !== asButton || $[19] !== className || $[20] !== iconOnly || $[21] !== size || $[22] !== variant) {
    t5 = cn(asButton ? buttonVariants({
      variant,
      size,
      className: iconOnly ? "h-8 w-8 p-0" : undefined
    }) : linkVariants({
      variant
    }), className);
    $[18] = asButton;
    $[19] = className;
    $[20] = iconOnly;
    $[21] = size;
    $[22] = variant;
    $[23] = t5;
  } else {
    t5 = $[23];
  }
  const classNameCombined = t5;
  if (isExternal) {
    let t6;
    if ($[24] !== children || $[25] !== classNameCombined || $[26] !== processedHref || $[27] !== props) {
      t6 = <a href={processedHref} target="_blank" rel="noopener noreferrer" className={classNameCombined} {...props}>{children}</a>;
      $[24] = children;
      $[25] = classNameCombined;
      $[26] = processedHref;
      $[27] = props;
      $[28] = t6;
    } else {
      t6 = $[28];
    }
    return t6;
  }
  let t6;
  if ($[29] !== children || $[30] !== classNameCombined || $[31] !== prefetch || $[32] !== processedHref || $[33] !== props) {
    t6 = <NextLink href={processedHref} className={classNameCombined} prefetch={prefetch} {...props}>{children}</NextLink>;
    $[29] = children;
    $[30] = classNameCombined;
    $[31] = prefetch;
    $[32] = processedHref;
    $[33] = props;
    $[34] = t6;
  } else {
    t6 = $[34];
  }
  return t6;
}
function _temp(acc, t0) {
  const [key, value] = t0;
  return value ? acc.replace(`:${key}`, value) : acc;
}